import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { setDataExpiracao } from "../../auth";
import { getTokenJWT } from "../../services/jwt"
import { ProgressSpinner } from 'primereact/progressspinner';

import "./style.css";
import { useQuery } from "../../hooks/useQuery";
import util from "../../utils/Util";
import { jwtVerify } from "jose";
import subscriptionService from "../../services/SubscriptionService";
import deparaService from "../../services/DeparaService";

function LoginConnect() {
  const navigate = useNavigate();
  const query = useQuery();
  const jwtToken = query.get('jwt')

  useEffect(() => {
    async function verifyAuthentication() {
      if (!util.isEmpty(jwtToken)) {
        try {
          const responseJwtToken = await getTokenJWT()
          window.localStorage.setItem('Authorization-Token', responseJwtToken.data.Authorization)
          var enc = new TextEncoder();
          const { payload } = await jwtVerify(jwtToken, enc.encode(process.env.REACT_APP_CONNECT_SECRET_TOKEN), { algorithms: ['HS256'] });
          const subscriptionDatail = await subscriptionService.findByConnectId(payload.asset_id);
          const customerIdOnPremisse = await deparaService.getTeste(subscriptionDatail.customerId)
        
          if (customerIdOnPremisse.length !== 0) {
            console.log("customerIdOnPremisse: "+customerIdOnPremisse[0]);
            window.localStorage.setItem('client_id', customerIdOnPremisse[0])
            window.localStorage.setItem('client_name', subscriptionDatail.clientName)
          } else {
            window.localStorage.setItem('client_id', subscriptionDatail.customerId)
            window.localStorage.setItem('client_name', subscriptionDatail.clientName)
          }

          setDataExpiracao(util.gerarDataExpiracaoSessao());
        } catch (error) {
          console.log(error);
          localStorage.clear();
        }
      }
      navigate("/dashboard");
    }

    
    verifyAuthentication()
  }, [])

  return (

    <div className="card  align-items-center justify-content-center card-login"  >
      <div className="field">
        <h3 style={{ textAlign: 'center' }}>Carregando...</h3>
      </div>
      <ProgressSpinner className="flex" style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
    </div>
  );
}

export default LoginConnect;
